import Vue from 'vue';
import Router from 'vue-router';
import mainRoutes from './main';
import store from '@/store';
Vue.use(Router);

const router = new Router({
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  mode: 'history',
  routes: [
    ...mainRoutes,
  ]
});

router.beforeEach((to, from, next) => {
  store.commit('layout/setCurrentRoute', to);
  store.commit('layout/setPrevRoute', from);

  next();
});

export default router;
